<ion-content>
  <div class="constrained-content">
    <ion-grid class="grid-no-padding">
      <ion-row>
        <ion-col size="6" size-md="6">
          <ion-card class="outline-card report-card">
            <ion-list>
              <ion-item class="transparent-bg" button="false">
                <img
                  class="zapier-logo"
                  src="{{
                    environment.assetsBaseUrl + '/imgs/zapier-logo_black.svg'
                  }}"
                  slot="start"
                  style="
                    border-radius: 10px;
                    max-width: 100px;
                    background: white;
                    padding: 5px;
                  "
                />
                <ion-label text-wrap>
                  <h3>Integrate with Zapier</h3>
                  <p>
                    <a
                      href="https://zapier.com/developer/public-invite/170323/75d6d7c7fbea3e022e73625f25d964e6/"
                      target="_blank"
                      >Click here to get access to the beta</a
                    >. If you need help setting up your account, you can
                    <a
                      href="https://docs.unthread.io/integrations/connecting-zapier"
                      target="_blank"
                      >learn more on our helpdesk</a
                    >.
                  </p>
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-card>
        </ion-col>
        <ion-col size="6" size-md="6">
          <ion-card class="outline-card report-card">
            <ion-list>
              <ion-item class="transparent-bg" button="false">
                <ion-icon
                  name="code-slash-outline"
                  style="font-size: 2rem; margin-right: 20px"
                ></ion-icon>
                <ion-label text-wrap>
                  <h3>Use the Unthread API</h3>
                  <p>
                    The Unthread API allows you to access your account data on
                    your terms. To get started,
                    <a
                      href="https://docs.unthread.io/api-introduction/using-api"
                      target="_blank"
                      >read our documentation</a
                    >.
                  </p>
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div class="flex-space-between" style="padding: 15px 5px 0 3px">
      <div class="button-container flexed-align-center">
        <ion-searchbar
          mode="ios"
          class="rounded-search-bar"
          placeholder="Search..."
          showCancelButton="never"
          [(ngModel)]="searchText"
        ></ion-searchbar>
        <div></div>
      </div>

      <div class="button-container flexed-align-center">
        <ion-button
          (click)="createServiceAccount()"
          [disabled]="!featureEnabled"
        >
          <span class="text-with-right-icon hidden-sm">
            Create service account
          </span>
          <ion-icon name="add-outline"></ion-icon>
        </ion-button>
        <ion-button
          (click)="openAddServiceAccountModal()"
          [disabled]="!featureEnabled"
        >
          <span class="text-with-right-icon hidden-sm"> Add existing </span>
          <ion-icon name="add-outline"></ion-icon>
        </ion-button>
      </div>
    </div>
    <ion-card class="outline-card" style="margin-top: 10px">
      <ngx-datatable
        [limit]="100"
        [loadingIndicator]="isLoading"
        class="material"
        [columnMode]="ColumnMode.force"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="50"
        [scrollbarH]="true"
        [rows]="serviceAccounts | filterCollection: searchText : ['name']"
        trackByProp="id"
      >
        <ngx-datatable-column name="Name" prop="user.name" [minWidth]="200">
          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
          >
            {{ row.user.name }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Role" [maxWidth]="150" [minWidth]="130">
          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
          >
            <div
              *ngIf="row.role === PROJECT_MEMBER_ROLES.OWNER"
              ngxTippy
              data-tippy-content="Can configure all aspects of the project"
              [tippyProps]="{
                placement: 'bottom'
              }"
            >
              <ion-icon
                name="{{ PROJECT_MEMBER_ROLE_ICONS[row.role] }}"
              ></ion-icon>
              {{ PROJECT_MEMBER_ROLE_NAMES[row.role] }}
              <a (click)="changeRole(row)" *ngIf="canEditUsers">
                <ion-icon name="chevron-down-outline"></ion-icon>
              </a>
            </div>

            <div
              *ngIf="row.role === PROJECT_MEMBER_ROLES.AGENT"
              ngxTippy
              data-tippy-content="Can respond to conversations in the project"
              [tippyProps]="{
                placement: 'bottom'
              }"
            >
              <ion-icon
                name="{{ PROJECT_MEMBER_ROLE_ICONS[row.role] }}"
              ></ion-icon>
              {{ PROJECT_MEMBER_ROLE_NAMES[row.role] }}
              <a (click)="changeRole(row)" *ngIf="canEditUsers">
                <ion-icon name="chevron-down-outline"></ion-icon>
              </a>
            </div>

            <div
              *ngIf="row.role === PROJECT_MEMBER_ROLES.STANDARD"
              ngxTippy
              data-tippy-content="Access to all conversations and customers in the project"
              [tippyProps]="{
                placement: 'bottom'
              }"
            >
              {{ PROJECT_MEMBER_ROLE_NAMES[row.role] }}
              <a (click)="changeRole(row)" *ngIf="canEditUsers">
                <ion-icon name="chevron-down-outline"></ion-icon>
              </a>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          name="Date"
          prop="user.createdAt"
          [minWidth]="170"
          [maxWidth]="170"
          [sortable]="false"
        >
          <ng-template
            let-value="value"
            let-row="row"
            ngx-datatable-cell-template
          >
            {{ row.user.createdAt | date: "MMM d yyyy h:mm a" }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="" prop="id" [sortable]="false">
          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
          >
            <a
              (click)="removeServiceAccount(row.userId)"
              title="Remove this service account from the project"
              ><span>Remove</span></a
            >
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </ion-card>
  </div>
</ion-content>

<ion-modal #addServiceAccountModal [cssClass]="'auto-height modal-sm'">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Add Service Account</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="addServiceAccountModal.dismiss()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <div class="inner-content" class="flex-space-between" style="padding: 8px">
      <ion-chip
        mode="ios"
        [outline]="true"
        class="select-chip select-outline"
        (click)="showUserOptions()"
        style="width: 58%"
      >
        <ion-label class="select-label">
          {{ newServiceAccount?.name ?? "None" }}
          <ion-icon
            name="chevron-down-outline"
            class="icon-padded-left"
          ></ion-icon>
        </ion-label>
      </ion-chip>
      <ion-chip
        mode="ios"
        [outline]="true"
        class="select-chip select-outline"
        (click)="showRoleOptions()"
        style="width: 38%"
      >
        <ion-label class="select-label">
          {{
            newServiceAccountRole
              ? PROJECT_MEMBER_ROLE_NAMES[newServiceAccountRole]
              : "Choose role..."
          }}
          <ion-icon
            name="chevron-down-outline"
            class="icon-padded-left"
          ></ion-icon>
        </ion-label>
      </ion-chip>
    </div>
    <div>
      <ion-footer class="footer ion-no-border">
        <ion-button
          (click)="submit()"
          [disabled]="isSubmitting || !isValidNewServiceAccount()"
        >
          Submit
          <ion-spinner
            name="crescent"
            [hidden]="!isSubmitting"
            style="margin-left: 10px"
          ></ion-spinner>
        </ion-button>
      </ion-footer>
    </div>
  </ng-template>
</ion-modal>
